import styled from "styled-components/macro"
import Color from "../../../constants/Color"
import { Link } from "react-router-dom"

export const HeroContainer = styled.div`
  position: relative;
  width: 100%;
  height: 460px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 12.5%, #000000 79.69%),
    url(${({ path }) => path});
  background-size: cover;
  background-position: top;
  object-fit: cover;
  overflow: hidden;

  @media (min-width: 640px) {
    height: 408px;
  }

  @media (min-width: 768px) {
    height: 450px;
  }

  @media (min-width: 1024px) {
    width: 100%;
    height: 680px;
    margin: 0 auto;
  }
`

export const HeroWrapper = styled.div`
  width: 100%;
  height: 100%;
`

export const HeroContent = styled.div`
  position: absolute;
  left: 16px;
  bottom: 24px;

  @media (min-width: 768px) {
    bottom: 40px;
    left: auto;
  }

  @media (min-width: 768px) {
    font-size: 36px;
  }
`

export const HeroTitle = styled.h2`
  font-size: 24px;
  color: ${Color.gray50};
  margin-bottom: 4px;

  @media (min-width: 1280px) {
    font-size: 36px;
    margin-bottom: 8px;
  }
`

export const Date = styled.h2`
  font-size: 12px;
  color: ${Color.gray300};
  margin-bottom: 6px;

  @media (min-width: 1280px) {
    font-size: 14px;
    margin-bottom: 6px;
  }
`

export const Year = styled.span`
  font-weight: 100;
`
export const HeroOverview = styled.p`
  width: 100%;
  height: 36px;
  line-height: 18px;
  padding-right: 16px;
  font-size: 13px;
  /* color: ${Color.gray300}; */
  color: ${Color.gray400};
  letter-spacing: 0.4px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: unset;

  @media (min-width: 640px) {
    width: 540px;
    height: auto;
    font-size: 14px;
  }
  @media (min-width: 768px) {
    width: 580px;
    font-size: 15px;
  }

  @media (min-width: 1280px) {
    width: 720px;
    font-size: 18px;
    line-height: 20px;
    margin-bottom: 8px;
  }
`

export const Rating = styled.div`
  display: inline-flex;
  font-size: 16px;
  padding: 2px 6px;
  font-weight: 700;
  background: ${({ bg }) =>
    bg
      ? bg
      : "linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.24) 100%)"};
  color: ${({ color }) => color};
  /* border-bottom: 0.5px solid ${({ color }) => color}; */
  /* border-top: 0.5px solid ${({ color }) => color}; */
  border-radius: 3px;
  z-index: 2;
  margin-bottom: 6px;

  &i {
    margin-right: 4px;
  }
  p {
    margin-left: 4px;
  }
`
export const GenereContainer = styled.div`
  display: flex;
  margin-bottom: 6px;
`

export const GenereLink = styled(Link)`
  /* color: #a1a1aa; */
  color: ${Color.gray400};
  font-size: 14px;
  line-height: 133%;
  letter-spacing: 1px;
  margin-right: 6px;
  text-decoration: none;
  transition: color 0.3s ease-in-out;

  @media (min-width: 640px) {
    font-size: 16px;
  }

  &:hover {
    color: ${Color.gray300};
  }

  &::after {
    content: "•";
    margin-left: 4px;
  }

  &:last-child::after {
    content: "";
  }
`
